import Common from '../../../Common'

export interface PbxDadTbrExceptionBody {
	pbx_destination_id: id
	name?: string
	start: string
	end: string
}

const Exception = class extends Common {
	allowed = (tbrId: id) =>
		this.get(`/pbxdad/tbr/${tbrId}/exception/allowed`)

	browse = (tbrId: id) =>
		this.get(`/pbxdad/tbr/${tbrId}/exception`)

	create = (tbrId: id, body: PbxDadTbrExceptionBody) =>
		this.post(`/pbxdad/tbr/${tbrId}/exception`, body)

	delete = (tbrId: id, id: id) =>
		this.doDelete(`/pbxdad/tbr/${tbrId}/exception/${id}`)
}

export default Exception
